import React from "react"
import { useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import DOMPurify from "dompurify"
import { read, utils, writeFile } from 'xlsx'
import _ from "lodash"
import Expiry from "./expiry"

import "../index.css"

import Button from "../../../helpers/Button"
import { InputSwitchField } from "../../../helpers"
import TextInputField from "../../../helpers/TextInputField"
import DropDownField from "../../../helpers/DropDownField"
import Tooltip from "../../../helpers/Tooltip"

import { Panel } from "primereact/panel"
import { Checkbox } from "primereact/checkbox"
import { Ripple } from "primereact/ripple"
import { OverlayPanel } from "primereact/overlaypanel"
import { FileUpload } from "primereact/fileupload"

import Loading from "../../../common/Loading"
import SendEmail from "../../../common/SendEmail"
import FileViewAndRemove from "../../../common/FileViewAndRemove"

import SingleTickImg from "../../../images/singletick.png"
import DoubleTickImg from "../../../images/double-tick.png"
import CheckCircleImg from "../../../images/check-circle.png"
import PendingDocument from "../../../images/pending_doc.png"

import { postSellerReq } from "../../../services/api/sellerReq"
import { uploadFile } from "../../../services/api/company"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"

import { sellerReqSchema } from "../../../validation/sellerReq"

import { getPaymentTermsString, numberConversion, round } from "../../../utils";
import { getBuyerProductSpecification, getDateString, getProductName, getProductQty, totalQuotationAmountCalculation, validateInputs, getReversePercentile, getListDiscountAndUnitPrices, getUOMStr, getUploadedFileObj } from "../../../utils"

import MaterialsPreviousTransactions from "./MaterialsPreviousTransactions"
import { DATE_FORMAT } from "../../../constants"
import { Dialog } from "primereact/dialog"


const VendorComponent = (props) => {
    let { 
        sellerReqsData, 
        sellerReq, 
        sellerReqItems, 
        userDetails, 
        setSellerReqs, 
        setInitialSellerReqs, 
        setInitialSellerReqItems, 
        setSellerReqItems, 
        materialDetails, 
        sellers, 
        selectedSellerReqs, 
        handleDiscardClick, 
        handleExpiryClick, 
        handleSellerReqDocs, 
        handleDeleteSellerReqDocs, 
        handleSelectSellerReq, 
        buyerReqItems, 
        handleSendMail, 
        handleToggler, 
        handleSellerQuoteChange,
        deliveryAddressList,
        buyerDetails,
        HSNMasterData,
        buyerReq,
        materialMandatoryUseFromStock,
        companyWarehousesData,
        PMBranches,
        isStarRFQ,
        vendorRateContractItems,
        PMCompanyConfig,
        pastSellerPOMaterialTransactions,
        isPrevSelPOMaterialTransactionsLoading,
        isPassRequirement,
        buyerBranchUsers,
        companyCreditPeriods
    } = props
    
    const op1 = useRef(null)
    const uploadedDocRef = useRef(null)
    const panelRef = useRef(null)

    const PMCompanyDetails = useSelector(state => state.userDetails.PMCompanyDetails)
    const states = useSelector(state => state.common.states)

    const [documents, setDocuments] = useState([])
    const [emailDetailsObj, setEmailDetailsObj] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [isEmailDialogVisible, setIsEmailDialogVisible] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [isDocProofRemoved, setIsDocProofRemoved] = useState(false)
    const [visibleMaterialImagesConfirmation, setVisibleMaterialImagesConfirmation] = useState(false)

    const dispatch = useDispatch()

    const sellerDetails = sellers.find(eachSeller => eachSeller.userId === sellerReq.userId)

    let relatedSellerReqItems = sellerReqItems.filter(eachSellerReqItem => eachSellerReqItem?.sellerReqId === sellerReq?.sellerReqId)
    relatedSellerReqItems = _.sortBy(relatedSellerReqItems, "materialId")

    const isNewSellerReq = relatedSellerReqItems.some(eachSellerReqItem => eachSellerReqItem?.isNew)

    let tableBorderStyle = "border: 1px solid black; border-collapse: collapse; padding: 3px; text-align: center;"
    let tableDataStyle = "padding: 6px 18px"
    let headerStyle = "color: black; font-weight: bold"

    let { numberLocale } = PMCompanyConfig
    
    let gstRates = PMCompanyConfig.GSTRates
    let isZeroGstRateExists = relatedSellerReqItems.some(eachSelReqItem => eachSelReqItem.quotGSTRate === 0)
    if ((sellerDetails && sellerDetails.gstinCode === "URD") || isZeroGstRateExists){
        if(!gstRates.includes(0)){
            gstRates = [0, ...gstRates]
        }
    }

    let gstOptions = []
    gstRates.map(eachGSTRate => gstOptions.push({label: eachGSTRate.toString(), GSTRate: eachGSTRate}))

    const handleSendMailClick = async (sellerReqId, uploadMaterialImages) => {
        if([3].includes(buyerReq.pmBranchId)){
            if(window.confirm("Confirm to save seller requisition")){
                handleSendMail({}, sellerReq?.sellerReqId)
            }
            return
        }

        let productsTableBodyString = ""
        let updatedSellerReqItems = sellerReqItems.filter(eachSellerReqItem => eachSellerReqItem?.sellerReqId === sellerReqId && eachSellerReqItem?.isNew)

        let files = []
        updatedSellerReqItems?.map((eachSellerReqItem, index) => {
            const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachSellerReqItem?.materialId) 
            const relatedBuyerReqItem = buyerReqItems?.find(eachBuyerReqItem => eachBuyerReqItem?.buyerReqItemId === eachSellerReqItem?.buyerReqItemId)
            let relatedShipAddress = PMCompanyDetails.companyBranchShipAddrs.find(eachShipAddr => eachShipAddr.shipAddrId === eachSellerReqItem.shipAddrId)

            if(uploadMaterialImages && relatedMaterial && relatedMaterial.materialImage){
                let attachments = relatedMaterial.materialImage.map(eachFile => { return { url: eachFile, file_name: eachFile } })
                files = [...files, ...attachments]
            }

            if(!relatedShipAddress){
                relatedShipAddress = deliveryAddressList.find(eachDeliveryAddr => eachDeliveryAddr.shipAddrId === relatedBuyerReqItem.delAddrId)
            }
            const relatedState = states.find(eachState => eachState.stateId === relatedShipAddress.stateId)

            let qtyStr = getProductQty(relatedBuyerReqItem?.qty, relatedMaterial?.UOM, relatedMaterial?.UOMValue)
            let uomStr = getUOMStr(eachSellerReqItem?.UOM, eachSellerReqItem?.UOMValue)
            /*productsTableBodyString += `
                <p style="${tableBorderStyle} ${tableDataStyle}">${index+1}. ${relatedMaterial?.productName}, ${relatedMaterial?.productSpecification}, Qty: ${qtyStr}, Delivery Addr: ${relatedDeliveryAddr?.shipAddr} ${relatedDeliveryAddr?.city} , ${relatedDeliveryAddr?.pinCode}</p>    
            `*/
            productsTableBodyString += `
                <tr>
                    <td style="${tableBorderStyle}">${index+1}</td>
                    <td style="${tableBorderStyle} ${tableDataStyle}">${relatedMaterial.brandName}-${relatedMaterial.productName}-${relatedMaterial.variantName}</td>
                    <td style="${tableBorderStyle} ${tableDataStyle}">${relatedMaterial.productSpecification} - ${uomStr}</td>
                    <td style="${tableBorderStyle} ${tableDataStyle}">${qtyStr}</td>
                    <td style="${tableBorderStyle} ${tableDataStyle}">${relatedShipAddress?.shipAddr}, ${relatedShipAddress?.city}, ${relatedState?.stateName}, ${relatedShipAddress?.pinCode}</td>
                </tr>
            `
        })

        let htmlString = `
            <div>
                <div>
                    <img alt="procmart logo" src="https://procmart-dev.s3.ap-south-1.amazonaws.com/logo.png">
                </div>

                <p> Dear Sir / Ma'am </p>
                <p> Greetings from ProcMart! </p>
                <p> Please submit your offer for the below-listed items within 1 business day. </p>
                <p> Kindly make sure your offer consists of Delivery Lead Time / Price Validity / Warranty / HSN / GST. </p>
                <p> Please share TDS / MSDS, where ever applicable. </p>
                <p> If you're the sole supplier of the item, please indicate this information on your bid.  </p>
                <p> If you're not an authorized distributor for this material, please indicate and decline to quote. </p>
                <p>Product Details:</p>

                <table style="border: 1px solid black; border-collapse: collapse; width: 100%; table-layout: fixed;">
                    <tr>
                        <td style="${tableBorderStyle} ${headerStyle}">S.No</td>
                        <td style="${tableBorderStyle} ${headerStyle}">Product Name</td>
                        <td style="${tableBorderStyle} ${headerStyle}">Product Specifications</td>
                        <td style="${tableBorderStyle} ${headerStyle}">Quantity</td>
                        <td style="${tableBorderStyle} ${headerStyle}">Shipment Address</td>
                    </tr>
                    ${productsTableBodyString}
                </table>
                <br />

                <p>* Request you to please share a quote with a year validity</p>

                <p>Substitutions should be indicated so information can be provided to our requester. ProcMart reserves the right to accept or reject, in whole or in part, any quotation and to select and quote of its choice without assigning any reason. Thank you in advance for your assistance.</p>

                <p style="margin-bottom:0px">Thanks & Regards:</p>
                <p style="margin:0px">${userDetails?.firstName + " " + userDetails?.lastName}</p> 
                <p style="margin:0px">${userDetails?.phoneNumber}</p>
                <p style="margin:0px">${userDetails?.emailId} </p>

                <p>Please do not reply to this email, replies to this message are routed to an unmonitored mailbox. If you have any questions please contact ${userDetails?.firstName + " " + userDetails?.lastName} (${userDetails?.emailId})</p>
            </div>
        `
        let sanitizedHTML = DOMPurify.sanitize(htmlString)

        let userEmail = userDetails.emailId
        let clientId = ""
        let refreshToken = ""
        let clientSecret = ""
        if(isPassRequirement && buyerDetails && buyerDetails.tags?.isPASSEnabled && buyerDetails.tags?.PASSEmailCredentials?.length && buyerBranchUsers.length){
            const passEmailCredentials = buyerDetails.tags.PASSEmailCredentials.find(eachPassCredential => {
                const relatedBuyerClientDetails = buyerBranchUsers.find(eachBuyerDetails => eachPassCredential.emailId === eachBuyerDetails.emailId)
                if(relatedBuyerClientDetails){
                    return true
                }
                return false
            })

            if (passEmailCredentials) {
                userEmail = passEmailCredentials.emailId
                clientId = passEmailCredentials.clientId
                refreshToken = passEmailCredentials.refreshToken
                clientSecret = passEmailCredentials.clientSecret
            }
        }

        const emailDetailObj = {
            to: sellerDetails?.emailId,
            from: userEmail,
            kam: userDetails.emailId,
            subject: `Request for Price Quotation | ${moment().format(DATE_FORMAT)} | ${sellerReq?.docNo}`,
            message: sanitizedHTML,
            cc: [],
            clientId,
            refreshToken,
            clientSecret,
            attachments: files
        }
        setEmailDetailsObj(emailDetailObj)
        setIsEmailDialogVisible(true)
    }

    const handleMail = (emailObj) => {
        let sanitizedHTML = DOMPurify.sanitize(emailObj?.message)
        emailObj = {...emailObj, message: sanitizedHTML, cc: [...emailObj?.cc, userDetails?.emailId]}
        handleSendMail(emailObj, sellerReq?.sellerReqId)
        setEmailDetailsObj({})
    }

    const handleEditClick = (e, sellerReqId) => {
        let updatedSellerReqs = sellerReqsData?.map(eachSellerReq => {
            if (eachSellerReq?.sellerReqId === sellerReqId){
                return {...eachSellerReq, disabled : false}
            }
            return eachSellerReq
        })
        setSellerReqs(updatedSellerReqs)
        setInitialSellerReqs(updatedSellerReqs)
        const updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
            if (eachSellerReqItem?.sellerReqId === sellerReqId){
                if(sellerDetails.gstinCode === "URD"){
                    eachSellerReqItem.quotGSTRate = 0
                }
                if (eachSellerReqItem?.statusId === 1 && sellerReq?.companyId !== sellerReq.pmCompanyId && !(eachSellerReqItem?.quotTotalAmountWithTax > 0)){
                    return {...eachSellerReqItem, isEditable : true, quotQty: eachSellerReqItem?.qty, canEditExpiredAndLogistics: true, isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? true : false}
                }else{
                    if (sellerReq.companyId === sellerReq.pmCompanyId && (!eachSellerReqItem?.quotHSNCode || !eachSellerReqItem?.quotLeadTime) && eachSellerReqItem?.statusId === 1){
                        return {...eachSellerReqItem, isEditable : true, canEditExpiredAndLogistics: true, isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? true : false}
                    }else{
                        return {...eachSellerReqItem, canEditExpiredAndLogistics: true, isEditable: false}
                    }
                }
            }
            return eachSellerReqItem
        })
        setSellerReqItems(updatedSellerReqItems)
        // setInitialSellerReqItems(updatedSellerReqItems)
    }

    const handleDiscard = () => {
        setFormErrors({})
        let updatedSellerReqs = sellerReqsData?.map(eachSellerReq => {
            if (eachSellerReq?.sellerReqId === sellerReq.sellerReqId){
                return {...eachSellerReq, disabled : false}
            }
            return eachSellerReq
        })
        setSellerReqs(updatedSellerReqs)
        setInitialSellerReqs(updatedSellerReqs)
        handleDiscardClick(sellerReq?.sellerReqId)
    }

    const fileUploadHandler = async ({ files, options }, docName, sellerReqId) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, documentName: docName, allowedFileTypes: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/csv', 'application/x-cfb'] })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }

        uploadExpenseRelatedCertificates(fileArr[0], sellerReqId)
    }

	const uploadExpenseRelatedCertificates = async (fileObj, sellerReqId) => {

        let data = {
            doc_name: fileObj.documentName,
            file_name: fileObj.fileName,
            data_uri: fileObj.dataURI,
        }

        setIsLoading(true)
        let response = await uploadFile(data)

        if (response.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Upload File", detail: response.data.error, life: 3000}))
        }
        else{
            let name = "docProof"
            handleSellerReqDocs(sellerReqId, name, [...documents, response.data])
            setDocuments(prevState => [...prevState, response.data])
            setIsLoading(false)
        }
    }

    const removeExpenseRelatedCertificates = (event, sellerReqId, docString) => {
        event.stopPropagation();
        let updatedDocuments = documents?.filter(eachDoc => eachDoc !== docString)
        setDocuments(updatedDocuments)
        handleDeleteSellerReqDocs(sellerReqId, docString)
        setIsDocProofRemoved(true)
    }
    
    const handleDownloadSampleFile = () => {
        const headers = ["materialId", "productName", "productSpecification", "quotQty", "quotLeadTime", "quotListPrice", "quotHSNCode", "quotDiscountRate", "quotUnitPrice", "GSTRate", "LogisticsBeforeTax", "LogisticsGSTRate"]
        
        let downloadSheetData = []
        let vrcMaterialIds = []
        relatedSellerReqItems.map(eachSellerReqItem => {
            if (eachSellerReqItem.isEditable) {
                const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === eachSellerReqItem.materialId)
                let sellerReqItem = {
                    materialId: eachSellerReqItem.materialId,
                    productName: relatedMaterial.productName,
                    productSpecification: relatedMaterial.productSpecification,
                    quotQty: eachSellerReqItem.quotQty,
                    quotLeadTime: eachSellerReqItem.quotLeadTime,
                    quotListPrice: eachSellerReqItem.quotListPrice,
                    quotHSNCode: eachSellerReqItem.quotHSNCode,
                    quotDiscountRate: eachSellerReqItem.quotDiscountRate,
                    quotUnitPrice: eachSellerReqItem.quotUnitPrice,
                    GSTRate: eachSellerReqItem.quotGSTRate,
                    LogisticsBeforeTax: eachSellerReqItem.quotLogisticsBeforeTax,
                    LogisticsGSTRate: eachSellerReqItem.quotLogisticsGSTRate ? eachSellerReqItem.quotLogisticsGSTRate : 0
                }

                downloadSheetData.push(sellerReqItem)
                
                const relatedVendorRateContractItem = vendorRateContractItems.find(eachVendorRateContract => eachVendorRateContract.vendorRateContractItemId === eachSellerReqItem.vendorRateContractItemId)
                if(relatedVendorRateContractItem){
                    vrcMaterialIds.push(eachSellerReqItem.materialId)
                }
            }
        })

        if(vrcMaterialIds.length){
            dispatch(raiseToast({ severity: 'info', detail: `${vrcMaterialIds.length > 1 ? "MaterialId's" : "MaterialId"}: ${vrcMaterialIds.join(", ")} are vendor rate contract items. Please change only necessary columns.` }))
        }

        // const sampleQuoteData = [
        //     {
        //         materialId: '100023',
        //         quotQty: 23,
        //         quotLeadTime: 21,
        //         quotListPrice: 100,
        //         quotHSNCode: 84831010,
        //         quotDiscountRate: 8,
        //         quotUnitPrice: 92,
        //         GSTRate: 12,
        //         AmtBeforeTax: 2116,
        //         AmtWithTax : 2369.92,
        //         LogisticsBeforeTax: 135,
        //         LogisticsGSTRate: 5
        //     },
        //     {
        //         materialId: '100129',
        //         quotQty: 30,
        //         quotLeadTime: 10,
        //         quotListPrice: 1.85,
        //         quotHSNCode: 84831010,
        //         quotDiscountRate: 0,
        //         quotUnitPrice: .85,
        //         GSTRate: 0,
        //         AmtBeforeTax: 37,
        //         AmtWithTax : 37,
        //         LogisticsBeforeTax: 150,
        //         LogisticsGSTRate: 18
        //     }
        // ]
        const ws = utils.json_to_sheet(downloadSheetData, { header: headers })
        const wb = utils.book_new()
        utils.book_append_sheet(wb, ws, 'Sample')
        writeFile(wb, 'SampleQuoteUploadFile.xlsx')
    }

    const handleUploadXLQuoteClick = () => {
        const relatedSellerReqItems = sellerReqItems?.filter(each => each.sellerReqId == sellerReq?.sellerReqId && each.isEditable === true)
        if (relatedSellerReqItems?.length === 0) {
            return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: `No materials found in sheet!`, life: 3000 }))
        }
        document.getElementById('upload-xl-form').click();
    }
    
    const handleProductsUploadFile = async (e) => {
        const relatedSellerReqItems = sellerReqItems?.filter(each => each.sellerReqId == sellerReq?.sellerReqId && each.isEditable === true)
        const gstRateList = gstOptions?.map(each=> each.GSTRate)
        setIsLoading(true)

        const reader = new FileReader()
        if (e.target.files[0]) {
            reader.readAsArrayBuffer(e.target.files[0])
            reader.onload = async (e) => {
                const data = e.target.result
                const workbook = read(data)
                const worksheet = workbook.Sheets[workbook.SheetNames[0]]
                let productsParsedData = utils.sheet_to_json(worksheet)
                productsParsedData = productsParsedData.filter(product => 
                    relatedSellerReqItems.some(item => item.materialId == product.materialId)
                )
                if(productsParsedData?.length ===0){
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: `Sheet is either empty or incorrect materialIds in the sheet.`, life: 3000 }))
                }
                const headers = ["materialId", "quotQty", "quotLeadTime", "quotListPrice", "quotHSNCode", "quotDiscountRate", "quotUnitPrice", "GSTRate", "LogisticsBeforeTax", "LogisticsGSTRate"]
                const allHeaders = new Set()

                productsParsedData.forEach(item => {
                    Object.keys(item).forEach(key => {
                        allHeaders.add(key)
                    })
                })

                const mandatoryHeaders = ["quotListPrice", "quotDiscountRate", "quotUnitPrice"]
                const presentMandatoryHeaders = mandatoryHeaders.filter(header => allHeaders.has(header))

                if (sellerReq.companyId === sellerReq.pmCompanyId) {
                    const mandatoryHeadersForUseStock = ["quotListPrice", "quotDiscountRate"]
                    const presentHeadersForUseStock = mandatoryHeadersForUseStock.filter(header => allHeaders.has(header))

                    if (presentHeadersForUseStock.length < 1) {
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: `For USE STOCK, quotListPrice and/or quotDiscountRate are mandatory`, life: 3000 }))
                    }
                } 
                else {
                    if (presentMandatoryHeaders.length < 2) {
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: `At least two of quotListPrice, quotDiscountRate, and quotUnitPrice are mandatory`, life: 3000 }))
                    }
                }

                const headersExcludingMandatory = headers.filter(header => !mandatoryHeaders.includes(header))
                let missingHeaders = []
                if (sellerReq.companyId === sellerReq.pmCompanyId) {
                    missingHeaders = headersExcludingMandatory.filter(header => !allHeaders.has(header) && !(header === 'LogisticsBeforeTax' || header === 'LogisticsGSTRate' || header === 'quotQty' || header === 'quotUnitPrice'  || header === 'GSTRate')) 
                }else if(sellerDetails?.gstinCode === "URD"){
                    missingHeaders = headersExcludingMandatory.filter(header => !allHeaders.has(header) && !(header === 'LogisticsBeforeTax' || header === 'LogisticsGSTRate' || header === 'GSTRate'))
                }
                 else {
                    missingHeaders = headersExcludingMandatory.filter(header => !allHeaders.has(header) && !(header === 'LogisticsBeforeTax' || header === 'LogisticsGSTRate'))
                }
                if (missingHeaders.length > 0) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: `Sheet is missing columns: ${missingHeaders.join(', ')}`, life: 3000 }))
                }

                let counter = 2;
                let filteredSheetData = []
                const invalidProductsPresent = productsParsedData.some(eachProduct => {
                    
                    const errors = []
                    const vrcErrors = []
                    if (sellerReq.companyId === sellerReq.pmCompanyId) {
                        const relatedSellerReqItem = relatedSellerReqItems?.find(each => each?.materialId == eachProduct.materialId)
                        let hasListPrice = !!eachProduct.quotListPrice;
                        let hasDiscountRate = !!eachProduct.quotDiscountRate

                        if (hasListPrice + hasDiscountRate  < 1) {
                            errors.push(`At least one of quotListPrice and quotDiscountRate is required`)
                        } else {
                            if (hasListPrice  && eachProduct.quotListPrice < relatedSellerReqItem.quotUnitPrice) {
                                errors.push(`List price in the sheet cannot be less than unit price ${relatedSellerReqItem.quotUnitPrice}`)
                            } else {
                                if (hasListPrice && hasDiscountRate) {
                                    if(eachProduct.quotListPrice !== relatedSellerReqItem.quotListPrice){
                                        const calculatedQuoteDiscountRate = ((eachProduct.quotListPrice - relatedSellerReqItem.quotUnitPrice) / eachProduct.quotListPrice) * 100
                                        eachProduct.quotDiscountRate = round(calculatedQuoteDiscountRate, 2)
                                    }else{
                                        eachProduct.quotDiscountRate = round(relatedSellerReqItem.quotDiscountRate, 2)
                                    }
                                }
                                if (!hasDiscountRate && hasListPrice) {
                                    const calculatedDiscountRate= ((eachProduct.quotListPrice - relatedSellerReqItem.quotUnitPrice) / eachProduct.quotListPrice) * 100
                                    eachProduct.quotDiscountRate  = round(calculatedDiscountRate, 2)
                                }
                                if (hasDiscountRate && !hasListPrice) {
                                    const calculatedListPrice = (relatedSellerReqItem.quotUnitPrice * 100) / (100 - eachProduct.quotDiscountRate)
                                    eachProduct.quotListPrice = round(calculatedListPrice, 2)
                                }
                            }
                        }
                    
                        const isHSNCodeValid = HSNMasterData?.some(each => each?.HSNCode === eachProduct?.quotHSNCode)
                        if (!isHSNCodeValid) {
                            errors.push(`Invalid HSN Code`)
                        }
                    
                        if (errors.length > 0) {
                            setIsLoading(false)
                            return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: `${errors.join(', ')} at line ${counter}`, life: 3000 }))
                        }else{
                            const filteredProduct = {
                                materialId: eachProduct.materialId,
                                quotLeadTime: eachProduct.quotLeadTime,
                                quotListPrice: eachProduct.quotListPrice,
                                quotHSNCode: eachProduct.quotHSNCode,
                                quotDiscountRate: eachProduct.quotDiscountRate
                            };
                            filteredSheetData.push(filteredProduct)
                            counter += 1
                        }
                    }
                    else{
                        const isHSNCodeValid = HSNMasterData?.some(each => each?.HSNCode === eachProduct?.quotHSNCode)
                        const HSNCodeRelatedGSTRates = HSNMasterData.filter(eachHSNCode => eachHSNCode.HSNCode === eachProduct.quotHSNCode).map(eachHSN => eachHSN.GSTRate)
                        
                        const gstRate = parseFloat(eachProduct?.GSTRate)
                        const isValidGSTRate = HSNCodeRelatedGSTRates.includes(gstRate)
                        
                        if (sellerDetails.gstinCode !== "URD" && !isValidGSTRate) {
                            errors.push(`Invalid GSTRate`)
                        }
                        if (!isHSNCodeValid) {
                            errors.push(`Invalid HSN Code`)
                        }

                        let hasListPrice = !!eachProduct.quotListPrice;
                        let hasDiscountRate = !!eachProduct.quotDiscountRate
                        let hasUnitPrice = !!eachProduct.quotUnitPrice;

                        if (hasListPrice + hasDiscountRate + hasUnitPrice < 2) {
                            errors.push(`At least two of quotListPrice, quotDiscountRate, and quotUnitPrice are mandatory`)
                        } else {
                            const relatedSellerReqItem = relatedSellerReqItems.find(eachSellerReqItem => eachSellerReqItem.materialId === eachProduct.materialId)
                            const relatedVendorRateContractItem = vendorRateContractItems.find(eachVendorRateContract => eachVendorRateContract.vendorRateContractItemId === relatedSellerReqItem.vendorRateContractItemId)

                            const {
                                vrcDiscoundCond = false,
                                vrcListPriceCond = false,
                                vrcUnitPriceCond = false,
                                vrcLeadTimeCond = false
                            } = relatedVendorRateContractItem ? getVRCConditionFlagsForSellerReq(relatedVendorRateContractItem) : {}
                            
                            if (relatedVendorRateContractItem) {
                                if (vrcListPriceCond && relatedVendorRateContractItem.listPrice !== eachProduct.quotListPrice) {
                                    vrcErrors.push(`list price`)
                                }

                                if (vrcLeadTimeCond && relatedVendorRateContractItem.leadTime !== eachProduct.quotLeadTime) {
                                    vrcErrors.push(`lead time`)
                                }

                                if (vrcUnitPriceCond && relatedVendorRateContractItem.contractPrice !== eachProduct.quotUnitPrice) {
                                    vrcErrors.push(`unit price`)
                                }

                                if (vrcDiscoundCond && relatedVendorRateContractItem.discount !== eachProduct.quotDiscountRate) {
                                    vrcErrors.push(`discount`)
                                }
                            }

                            if ( hasListPrice && hasUnitPrice && eachProduct.quotListPrice < eachProduct.quotUnitPrice) {
                                errors.push(`List price cannot be less than unit price`)
                            } else if (hasUnitPrice && hasDiscountRate && hasListPrice) {
                                let calculatedUnitPrice = eachProduct.quotListPrice * (1 - eachProduct.quotDiscountRate / 100)
                                if (calculatedUnitPrice !== eachProduct.quotUnitPrice) {
                                    errors.push(`Something is incorrect among unit price, discount rate, and list price`)
                                }
                            } else if (!hasUnitPrice) {
                                eachProduct.quotUnitPrice = eachProduct.quotListPrice * (1 - eachProduct.quotDiscountRate / 100)
                            } else if (!hasDiscountRate) {
                                eachProduct.quotDiscountRate = round(((eachProduct.quotListPrice - eachProduct.quotUnitPrice) / eachProduct.quotListPrice) * 100 , 2)
                            } else if (!hasListPrice) {
                                eachProduct.quotListPrice = (eachProduct.quotUnitPrice * 100) / (100 - eachProduct.quotDiscountRate)
                            }
                        }

                        const calculatedAmtBeforeTax = eachProduct.quotQty * eachProduct.quotUnitPrice;
                        const calculatedAmtWithTax = calculatedAmtBeforeTax + (calculatedAmtBeforeTax * gstRate / 100)
                        // if(!eachProduct.AmtBeforeTax){
                        //     errors.push('AmountBeforeTax can not be empty')
                        // }else if(Math.abs(eachProduct.AmtBeforeTax - calculatedAmtBeforeTax) > 2) {
                        //     errors.push(`AmountBeforeTax calculation is incorrect`)
                        // }

                        // if (sellerDetails.gstinCode !== "URD" && eachProduct.AmtWithTax) {
                        //     if(Math.abs(eachProduct.AmtWithTax - calculatedAmtWithTax) > 2){
                        //         errors.push(`AmountWithTax calculation is incorrect`)
                        //     }
                        // }else if(sellerDetails.gstinCode !== "URD" && !eachProduct.AmtWithTax){
                        //     errors.push(`AmountWithTax can not be empty`)
                        // }

                        eachProduct.AmtBeforeTax = calculatedAmtBeforeTax
                        eachProduct.AmtWithTax = calculatedAmtWithTax

                        if ('LogisticsBeforeTax' in eachProduct) {
                            if ('LogisticsGSTRate' in eachProduct) {
                                const logisticsBeforeTax = parseFloat(eachProduct.LogisticsBeforeTax);
                                const logisticsGSTRate = parseFloat(eachProduct.LogisticsGSTRate);

                                if (!gstRateList.includes(logisticsGSTRate)) {
                                    errors.push(`Invalid LogisticsGSTRate`);
                                }

                                const logisticsWithTax = logisticsBeforeTax + logisticsBeforeTax * logisticsGSTRate / 100;
                                eachProduct.LogisticsWithTax = logisticsWithTax;
                                eachProduct.showLogistics = true;
                            } else {
                                errors.push(`LogisticsGSTRate must be included for Logistics charges`);
                            }
                        } else if ('LogisticsGSTRate' in eachProduct) {
                            errors.push(`LogisticsBeforeTax column must be included for Logistics charges`);
                        }

                        if (errors.length > 0) {
                            const vrcErrorMsg = vrcErrors.length ? ` and it is a vendor rate contract item, so you can't modify the ${vrcErrors.join(', ')}` : null
                            setIsLoading(false)
                            dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: `${errors.join(', ')} for material ${eachProduct.materialId},${vrcErrorMsg ? vrcErrorMsg : ""} at line ${counter}.`, life: 3000 }))
                            return true
                        } else if (vrcErrors.length) {
                            setIsLoading(false)
                            dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: `Material ${eachProduct.materialId} is a vendor rate contract item, So can't modify the ${vrcErrors.join(", ")} at line ${counter}`, life: 3000 }))
                            return true
                        } else {
                            filteredSheetData.push(eachProduct);
                        }
                    }
                    counter += 1
                    return false
                })

                if (invalidProductsPresent) {
                    return
                }
                let updatedItems = []
                if(sellerReq?.companyId === sellerReq.pmCompanyId){
                    updatedItems = filteredSheetData.map((row) => ({
                        sellerReqId: sellerReq?.sellerReqId,
                        materialId: row?.materialId,
                        quotLeadTime: row?.quotLeadTime,
                        quotListPrice: row?.quotListPrice,
                        quotHSNCode: row?.quotHSNCode,
                        quotDiscountRate: row?.quotDiscountRate,

                    }))
                }else{
                    updatedItems = filteredSheetData.map((row) => ({
                        sellerReqId: sellerReq?.sellerReqId,
                        materialId: row?.materialId,
                        quotLeadTime: row?.quotLeadTime,
                        quotQty: row.quotQty,
                        quotListPrice: row?.quotListPrice,
                        quotHSNCode: row?.quotHSNCode,
                        quotDiscountRate: row?.quotDiscountRate,
                        quotUnitPrice: row?.quotUnitPrice,
                        quotGSTRate: sellerDetails.gstinCode !== "URD" ? row?.GSTRate : 0,
                        totalAmountBeforeTax: row?.AmtBeforeTax,
                        totalAmountWithTax: sellerDetails.gstinCode !== "URD" ? row?.AmtWithTax : row?.AmtBeforeTax,
                        quotLogisticsBeforeTax: row?.LogisticsBeforeTax,
                        quotLogisticsGSTRate: row?.LogisticsGSTRate,
                        quotLogisticsWithTax: row?.LogisticsWithTax,
                        showLogistics: row?.showLogistics || false
                    }))
                }
                const newSellerReqItems = sellerReqItems.map(item =>
                    updatedItems.find(updatedItem => updatedItem.sellerReqId === item.sellerReqId && item.isEditable == true)
                        ? { ...item, ...updatedItems.find(updatedItem => updatedItem.materialId === item.materialId) }
                        : item
                )
                setSellerReqItems(newSellerReqItems)
                setIsLoading(false)
                dispatch(raiseToast({ severity: 'success', summary: "Upload File", detail: `Quote file is uploaded successfully against matching materials.`, life: 3000 }))
            }
        }
        e.target.value = ""
    }

    const handleSaveClick = async (sellerReqId) => {

        let relatedSellerReqItems = sellerReqItems.filter(eachSellerReqItem => eachSellerReqItem.sellerReqId === sellerReqId)
        let previousSellerReqItems = sellerReqItems.filter(eachSellerReqItem => !eachSellerReqItem.isNew)

        relatedSellerReqItems.map(eachSellerReqItem => {
            const calculatedTaxValues = totalQuotationAmountCalculation(eachSellerReqItem)
            eachSellerReqItem.quotTotalAmountBeforeTax = calculatedTaxValues?.totalAmountBeforeTax 
            eachSellerReqItem.quotTotalAmountWithTax = calculatedTaxValues?.totalAmountWithTax
            eachSellerReqItem.quotLogisticsWithTax = calculatedTaxValues?.quotLogisticsWithTax
            eachSellerReqItem.gstinCode = sellerDetails?.gstinCode
        })
        relatedSellerReqItems = _.sortBy(relatedSellerReqItems, "materialId")

        const relatedSeller = sellers?.find(eachSeller => eachSeller?.userId === sellerReq?.userId)
        const allActiveSellerReqItems = sellerReqItems.filter(item => item.statusId === 1)
        const totalAmountBeforeTaxForAllActiveItems = allActiveSellerReqItems.reduce((sum, item) => {
            return sum + (item.quotTotalAmountBeforeTax || 0)
        }, 0)
        
        const filteredSellerReqItems = relatedSellerReqItems?.filter(eachSellerReqItem => eachSellerReqItem?.quotQty > 0 || eachSellerReqItem.isNew) 

        const invalidSellerReqItem = filteredSellerReqItems.some(eachSellerReqItem => {
            if (eachSellerReqItem.isHSNEditable && eachSellerReqItem.statusId === 1 && !eachSellerReqItem.isNew) {
                dispatch(raiseToast({ severity: 'error', detail: `Please confirm and save HSN Code, material Id: ${eachSellerReqItem.materialId}` }))
                return true
            }
            if ((!eachSellerReqItem.quotGSTRate && eachSellerReqItem.quotGSTRate !== 0) && eachSellerReqItem.statusId === 1 && !eachSellerReqItem.isNew) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter GST rate!` }))
                return true
            }
            return false
        })
        if(invalidSellerReqItem){
            return 
        }

        const data = {
            sellerReq: {...sellerReq, emailId: relatedSeller?.emailId},  
            sellerReqItems: filteredSellerReqItems,
            prevSellerReqItems: previousSellerReqItems
        }

        setIsLoading(true)
        if (filteredSellerReqItems.length === 0){
            const validateErrs = await validateInputs(sellerReqSchema, relatedSellerReqItems)
            if (validateErrs.error){
                setFormErrors(validateErrs.error)
            }else{
                setFormErrors({})
            }
            setIsLoading(false)
            dispatch(raiseToast({ severity: 'error', detail: `Please Enter the quotation details` }))
        } 
        else {
            const validateErrs = await validateInputs(sellerReqSchema, relatedSellerReqItems)
            if(validateErrs.error){
                setFormErrors(validateErrs.error)
                setIsLoading(false)
            } else {
                setFormErrors({})
                if (isDocProofRemoved && (!documents || documents.length === 0)) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', detail: 'Doc Proof cannot be removed. Please upload and proceed.', life: 3000 }))
                }

                const isHSNCodeLength = filteredSellerReqItems?.some(eachSellerReqItem => {
                    return eachSellerReqItem?.quotHSNCode?.toString().length < 6 && sellerReq?.companyId === sellerReq?.pmCompanyId && eachSellerReqItem?.statusId === 1
                }) 
                
                if (isHSNCodeLength){
                    setIsLoading(false)
                    return dispatch(raiseToast({severity:'error', detail:'HSNCode Should contain atleast 6 numbers.', life: 3000}))
                }

                let isServiceHSNsProductsExists = data?.sellerReqItems?.some(eachSellerReqItem => {
                    if(eachSellerReqItem.quotHSNCode?.toString().slice(0, 2) === '99' && eachSellerReqItem.quotHSNCode?.toString().length === 6){
                        return true
                    }
                    return false
                })

                const zeroGSTRateExist = sellerReqItems.some(each => each.quotGSTRate === 0)
                let windowMsg = "Do You Want to continue..?"

                if (isServiceHSNsProductsExists && zeroGSTRateExist){
                    if (sellerDetails.tdsSectionId === 1 || !sellerDetails.tdsSectionId) {
                        windowMsg = "Please note: Services are not enabled for the vendor - This will need to be enabled and approved by finance, before raising seller PO for services. Also Proceeding with 0 GSTRate for some items. Are you sure to continue?"
                    }else{
                        windowMsg = "Proceeding with 0 GSTRate for some items. Are you sure to continue?"
                    }
                }
                else if(isServiceHSNsProductsExists && !zeroGSTRateExist){
                    if (sellerDetails.tdsSectionId === 1 || !sellerDetails.tdsSectionId) {
                        windowMsg = "Please note: Services are not enabled for the vendor - This will need to be enabled and approved by finance, before raising seller PO for services. Do you want to continue?"
                    }
                }
                else if(!isServiceHSNsProductsExists && zeroGSTRateExist){
                    windowMsg = "Proceeding with 0 GSTRate for some items. Are you sure to continue?"
                }

                if (window.confirm(windowMsg)){
                    const response = await postSellerReq(data)
                    if (response.failure){
                        dispatch(raiseToast({severity:'error', summary: response.data.error, detail:'Seller Req Details has not Saved', life: 3000}))
                    } else {
                        const updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                            if (eachSellerReqItem?.sellerReqId === sellerReqId){
                            return {...eachSellerReqItem, isEditable : false, canEditExpiredAndLogistics: false, isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true}
                            }
                            return eachSellerReqItem
                        })
                        let updatedSellerReqs = sellerReqsData?.map(eachSellerReq => {
                            if (eachSellerReq?.sellerReqId === sellerReqId){
                                return {...eachSellerReq, disabled : true}
                            }
                            return eachSellerReq
                        })
                        setSellerReqs(updatedSellerReqs)
                        setInitialSellerReqs(updatedSellerReqs)
                        setSellerReqItems(updatedSellerReqItems)
                        setInitialSellerReqItems(updatedSellerReqItems)
                        if(totalAmountBeforeTaxForAllActiveItems >= 500000){

                            const sellerReqsWithQuotedItems = sellerReqsData.filter(sellerReq => 
                                sellerReqItems.some(item => item.sellerReqId === sellerReq.sellerReqId && item.quotTotalAmountWithTax > 0)
                            )
                            const hasNullDocProof = sellerReqsWithQuotedItems.some(sellerReq => 
                                sellerReq.docProof === null || 
                                (Array.isArray(sellerReq.docProof) && sellerReq.docProof.length === 0)
                            )
                            if(hasNullDocProof){
                                dispatch(raiseToast({severity:'warn', detail:'Seller Req Details have Saved. Please note: This is a star RFQ! Seller quotation proof is mandatory for all seller quotations before buyer Quote can be generated', life: 3000}))
                            }else{
                                dispatch(raiseToast({severity:'success', summary: response.message, detail:'Seller Req Details have Saved', life: 3000}))
                            }
                        }else{
                            dispatch(raiseToast({severity:'success', summary: response.message, detail:'Seller Req Details have Saved', life: 3000}))
                        }
                    }
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            }
        }
    }

    const getVRCConditionFlagsForSellerReq = (vendorRateContractItem) => {
        let vrcDiscoundCond = false
        let vrcListPriceCond = false
        let vrcUnitPriceCond = false
        let vrcLeadTimeCond = false

        if (vendorRateContractItem && vendorRateContractItem.vendorRCTypeId === 1) {
            vrcDiscoundCond = true
            vrcLeadTimeCond = true
        }
        if (vendorRateContractItem && vendorRateContractItem.vendorRCTypeId === 2) {
            vrcUnitPriceCond = true
            vrcDiscoundCond = true
            vrcListPriceCond = true
            vrcLeadTimeCond = true
        }
        if (vendorRateContractItem && vendorRateContractItem.vendorRCTypeId === 3) {
            vrcUnitPriceCond = true
            vrcLeadTimeCond = true
            if (vendorRateContractItem.listPrice) {
                vrcDiscoundCond = true
                vrcListPriceCond = true
            }
        }

        return { vrcDiscoundCond, vrcListPriceCond, vrcUnitPriceCond, vrcLeadTimeCond }
    }

    const vendorTemplate = (options) => {
        let toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const className = `${options.className} justify-content-between`;
        const updatedSellerReqItems = relatedSellerReqItems?.filter(eachSellerReqItem => eachSellerReqItem?.statusId === 1)
        const isNewSellerReqItem =  updatedSellerReqItems?.some(eachSellerReqItem => eachSellerReqItem?.isNew)
        const allQuotationsSent = updatedSellerReqItems?.every(eachSellerReqItem => eachSellerReqItem?.quotQty > 0 && eachSellerReqItem?.quotTotalAmountWithTax > 0)
        const latestSellerReqItem = _.maxBy(relatedSellerReqItems, "createdAt")
        const isDocumentUploaded = sellerReq?.docProof?.length > 0
        const relatedVendorRateContractItem = vendorRateContractItems.find(eachVendorRateContract => eachVendorRateContract.vendorRateContractId === sellerReq.vendorRateContractId)
        const validSellerReqItems = updatedSellerReqItems.filter(eachSellerReqItem => eachSellerReqItem.quotQty > 0)

        const relatedMaterialIds = _.map(updatedSellerReqItems.filter(eachSellerReqItem => eachSellerReqItem.isNew), 'materialId')
        const relatedMaterialDetails = materialDetails.filter(eachMaterial => relatedMaterialIds.includes(eachMaterial.materialId))
        const isMaterialImagesFound = relatedMaterialDetails.some(eachMaterial => eachMaterial.materialImage?.length)
        
        let totalQuoteAmount = 0
        let totalLogisticsAmount = 0
        validSellerReqItems.forEach(eachSellerReqItem => {
            const { totalAmountWithTax, quotLogisticsWithTax } = totalQuotationAmountCalculation(eachSellerReqItem)
            totalQuoteAmount += (parseFloat(totalAmountWithTax) || 0) - (parseFloat(quotLogisticsWithTax) || 0)
            totalLogisticsAmount += parseFloat(quotLogisticsWithTax) || 0
        })
        totalQuoteAmount = totalQuoteAmount ? `${PMCompanyConfig.currencySymbol}${numberConversion(round(totalQuoteAmount, 2))}${totalLogisticsAmount ? ` + ${round(totalLogisticsAmount, 2)}(Logistics)` : ""}` : '-'
    
        let imgUrl = ""

        if (isNewSellerReqItem){
            imgUrl = ""
        }else if (!isNewSellerReqItem && !allQuotationsSent){
            imgUrl = SingleTickImg
        }else if (!isNewSellerReqItem && allQuotationsSent && !isDocumentUploaded){
            if(isStarRFQ){
                imgUrl = PendingDocument
            }else{
                imgUrl = DoubleTickImg
            }
        }else if (!isNewSellerReqItem && allQuotationsSent && isDocumentUploaded){
            imgUrl = CheckCircleImg
        }

        const emailRestrictedPMBranchIds = [3]
        let isEmailRestricted = emailRestrictedPMBranchIds.includes(buyerReq.pmBranchId)

        const { paymentTermsString } = getPaymentTermsString(sellerDetails.companyPaymentTerms, companyCreditPeriods)

        return (
            <div className={className} style={{ display: "flex", padding:"3px 10px" , justifyContent: "", fontFamily: "Amazon Ember,Arial,sans-serif" }}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <div className="flex flex-row justify-content-start ml-5" style={{flex: 1, alignItems:"center"}}>
                    <div className="flex align-items-center">
                        <Checkbox inputId="selectAllVendor" checked={selectedSellerReqs.includes(sellerReq?.sellerReqId)} disabled={sellerReq?.disabled} onChange={() => handleSelectSellerReq(sellerReq?.sellerReqId)} />
                        <div className="flex flex-column">
                            <div className="flex m-0 ml-3 align-items-center">
                                <p className="m-0"><span style={{ fontWeight: 700 }}>{sellerDetails?.name}</span> | {sellerDetails && sellerDetails.emailId} {latestSellerReqItem?.sellerReqItemId && ` | E-mail Sent: ${moment(latestSellerReqItem?.createdAt).format(DATE_FORMAT)} ${relatedVendorRateContractItem ? '| Vendor rate contract' : ''}`}</p>
                                <img src={imgUrl} style={{ height: imgUrl === `${PendingDocument}` ? 15 : 20, marginLeft: 10, }} className={`custom-tool-tip-${sellerReq?.sellerReqId}`} />
                                {imgUrl === PendingDocument && (
                                    <Tooltip target={`.custom-tool-tip-${sellerReq?.sellerReqId}`} position="right" autoHide >
                                        Doc proof upload is pending. Its mandatory for star RFQ.
                                    </Tooltip>
                                )}
                            </div>
                            <div className="flex align-items-center ml-3">
                                <p className="m-0 mr-2 font-semibold cursor-pointer text-xs" onClick={() => window.open(`/company/${sellerDetails.companyId}`)}>{sellerDetails.companyName}</p>
                                <p className="m-0 text-xs">({paymentTermsString})</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mr-4">
                    <p className="font-medium"><span className="font-semibold">Quote Value: </span>{totalQuoteAmount || '-'}</p>
                </div>
                {sellerReq.disabled && <Button className="small-btn ml-3" label="Uploaded Docs" style={{fontSize: "12px"}} onClick={(e) => uploadedDocRef.current.toggle(e)}/>}
                <OverlayPanel className="overlay-panel p-2" ref={uploadedDocRef}>
                    <div className="overlaypanel-list" style={{ width: "16vw", height: "10vh", overflowY: "auto" }} >
                        <ul style={{ paddingLeft: "0px" }}>
                            {
                                sellerReq.docProof?.length ? sellerReq.docProof?.map((eachDoc, index) => (
                                    <li className="vendor-details-li flex flex-wrap" key={eachDoc}>
                                        <a className="view-btn mr-3">{`${index+1})`}</a>
                                        <a href={eachDoc} className="view-btn mr-3" target="_blank">View</a>
                                    </li>
                                ))
                                :
                                <p> Doc proof upload is pending.</p>
                            }
                        </ul>
                    </div>
                </OverlayPanel>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    { 
                        isNewSellerReq ? ( 
                            <Button className="small-btn ml-3" label={isEmailRestricted ? "SAVE": "Send Email"} style={{fontSize: "12px"}} onClick={() => isMaterialImagesFound ? setVisibleMaterialImagesConfirmation(true) : handleSendMailClick(sellerReq.sellerReqId, false)} permissions={[6]}/> 
                        ) : (
                            sellerReq?.disabled ? (
                                        <>
                                            {sellerReq.docProof && <Button className="small-btn ml-3" label="Uploaded Docs" style={{fontSize: "12px"}} onClick={(e) => uploadedDocRef.current.toggle(e)} permissions={[6]}/>}
                                            <Button className="small-btn ml-3" label="Edit" style={{fontSize: "12px"}} onClick={(e) => handleEditClick(e, sellerReq?.sellerReqId)} permissions={[6]}/>
                                        </>
                                    ) : (
                                    <>
                                        <Button label={sellerReq?.docProof?.length > 0 ? `Upload (${sellerReq?.docProof?.length})` : "Upload"}  type="file" className="small-btn" onClick={(e) => op1.current.toggle(e)} permissions={[6]}/>
                                        <Button className="small-btn ml-3 discard-btn" label="Discard" style={{fontSize : "12px"}} onClick={(e) => {handleDiscard()}} permissions={[6]}/>
                                        <Button className="small-btn ml-3" label="Save" style={{fontSize: "12px", border : 0, backgroundColor: "purple"}} onClick={() =>handleSaveClick(sellerReq?.sellerReqId)} permissions={[6]}/>
                                    </>
                                    )
                        )
                    }
                    <OverlayPanel className="overlay-panel p-2" ref={uploadedDocRef}>
                        <div className="overlaypanel-list" style={{ width: "16vw", height: "10vh", overflowY: "auto" }} >
                            <ul style={{ paddingLeft: "0px" }}>
                                {
                                    sellerReq.docProof?.map((eachDoc, index) => (
                                        <li className="vendor-details-li flex flex-wrap" key={eachDoc}>
                                            <a className="view-btn mr-3">{`${index+1})`}</a>
                                            {/* <a href={eachDoc} className="view-btn mr-3" target="_blank">View</a> */}
                                            <FileViewAndRemove doc={{url: eachDoc}} docName="seller req upload" showRemove={false} />
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </OverlayPanel>
                    <OverlayPanel className="overlay-panel p-2" ref={op1}>
                        <div className="p-1 flex justify-content-end">
                            <FileUpload mode="basic" name="docProof" accept="image/pdf" customUpload uploadHandler={(files) => fileUploadHandler(files , "SELLER_REQUISITION", sellerReq?.sellerReqId)} auto chooseLabel='Upload Proof' />
						</div>			
                        <div className="p-1 flex justify-content-end">
                            <Button mode="basic" style={{height: "29px", fontSize: "12px"}} name="docProof" onClick={handleDownloadSampleFile} auto label='Download Sample Sheet' />
						</div>			
                        <div className="p-1 flex justify-content-end">
                            <Button label="Upload Quote" style={{height: "29px", fontSize: "12px"}} onClick={handleUploadXLQuoteClick} />
                            <input type="file" accept=".xlsx, .xls" className='hidden' onChange={handleProductsUploadFile} id='upload-xl-form' />
						</div>	
                        <div className="overlaypanel-list" style={{ width: "16vw", height: "10vh", overflowY: "auto" }} >
                            <ul style={{ paddingLeft: "0px" }}>
                                {
                                    sellerReq.docProof?.map((eachDoc, index) => (
                                        <li className="vendor-details-li flex flex-wrap" key={eachDoc}>
                                            <a className="view-btn mr-3">{`${index+1})`}</a>
											{/* <a href={eachDoc} className="view-btn mr-3" target="_blank">View</a> */}
                                            <FileViewAndRemove docName="seller req upload" doc={{url: eachDoc}} showRemove={false} />
											<a style={{cursor : "pointer"}} className="vendor-component-remove-btn ml-2" name="remove_invoice" onClick={(event) => removeExpenseRelatedCertificates(event, sellerReq.sellerReqId, eachDoc)} >Remove</a>
										</li>
                                    ))
                                }
                            </ul>
                        </div>
                    </OverlayPanel>
                </div>
                <SendEmail emailDetailsObj={emailDetailsObj} visible={isEmailDialogVisible} handleSendMail={handleMail} setEmailDetailsObj={setEmailDetailsObj} onHide={() => setIsEmailDialogVisible(current => !current)}/>
            </div>
        )
    }

    const handleToggle = async (name, value, sellerReqItemId) => {
        handleToggler(sellerReqItemId, name, value)
    }

    const handleChange = (data) => {
        const {e} = data 

        const sellerDetails = sellers.find(eachSeller => eachSeller.userId === sellerReq.userId)

        if(e.target.name === "quotGSTRate" && sellerDetails.gstinCode === "URD"){
            e.target.value = 0
        }
        
        handleSellerQuoteChange(data)
    }  

    const handleApplySellerPOPastValues = (sellerReqItemId, pastPOItem) => {
        const updatedSellerReqItems = sellerReqItems.map(eachSellerReqItem => {
            if(sellerReqItemId === eachSellerReqItem.sellerReqItemId){
                let discount = 0
                let listPrice = pastPOItem.unitPrice

                let updatedValues = {}
                try{
                    updatedValues = getListDiscountAndUnitPrices("contractPrice", pastPOItem.listPrice, 0, pastPOItem.unitPrice)
                } catch(discountErr){
                    console.log("discountErr", discountErr)
                }
                if(updatedValues.discount){
                    discount = updatedValues.discount
                }
                if(updatedValues.listPrice){
                    listPrice = updatedValues.listPrice
                }

                return {
                    ...eachSellerReqItem,
                    quotHSNCode: pastPOItem.HSNCode,
                    quotGSTRate: pastPOItem.GSTRate,
                    quotLeadTime: pastPOItem.leadTime,
                    quotListPrice: listPrice,
                    quotUnitPrice: pastPOItem.unitPrice,
                    quotDiscountRate: discount,
                }
            }
            return eachSellerReqItem
        })
        setSellerReqItems(updatedSellerReqItems)

        dispatch(raiseToast({ severity:"warn", detail: "Pleae re-validate Leadtime, HSNCode & Amt. With tax" }))
    }

    const handleMaterialImagesConfirmationFooter = () => {
        return (
            <div className="mt-2">
                <Button label="No" severity="danger" outlined onClick={() => { handleSendMailClick(sellerReq.sellerReqId, false); setVisibleMaterialImagesConfirmation(false); }} />
                <Button label="Yes" outlined onClick={() => { handleSendMailClick(sellerReq.sellerReqId, true); setVisibleMaterialImagesConfirmation(false); }} />
            </div>
        )
    }

    const handleHSNSave = (sellerReqItemId, hsnCode) => {
        if (!hsnCode) {
            return dispatch(raiseToast({ severity: "warn", detail: "Pleae enter HSN" }))
        }

        const relatedHSNCodes = HSNMasterData.filter(eachCode => eachCode.HSNCode === parseInt(hsnCode))
        if (relatedHSNCodes.length === 0) {
            return dispatch(raiseToast({ severity: 'error', detail: "Invalid HSN" }))
        }

        const updatedSellerReqItems = sellerReqItems.map(eachSelReqItem => {
            if (eachSelReqItem.sellerReqItemId === sellerReqItemId) {
                if(sellerReq.companyId !== sellerReq.pmCompanyId && eachSelReqItem.quotGSTRate){
                    const relatedGSTOptions = getGSTRatesByHSNCode(hsnCode)
                    const relatedGSTRate = relatedGSTOptions.find(eachGST => {
                        return parseInt(eachGST.GSTRate) === parseInt(eachSelReqItem.quotGSTRate)
                    })
                    if(!relatedGSTRate){
                        return { ...eachSelReqItem, isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true, quotGSTRate: null }
                    }
                }
                return { ...eachSelReqItem, isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true }
            }
            return eachSelReqItem
        })

        setSellerReqItems(updatedSellerReqItems)
    }

    const handleHSNDiscard = (sellerReqItemId) => {
        const updatedSellerReqItems = sellerReqItems.map(eachSelReqItem => {
            if(eachSelReqItem.sellerReqItemId === sellerReqItemId){
                return {...eachSelReqItem, quotHSNCode: null, quotGSTRate: null }
            }
            return eachSelReqItem
        })

        setSellerReqItems(updatedSellerReqItems)
    }

    const handleHSNCodeEditable = (sellerReqItemId, hsnEditableCond) => {
        if (hsnEditableCond) {
            const updatedSellerReqItems = sellerReqItems.map(eachSelReqItem => {
                if (eachSelReqItem.sellerReqItemId === sellerReqItemId) {
                    return { ...eachSelReqItem, isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? true : false }
                }
                return eachSelReqItem
            })

            setSellerReqItems(updatedSellerReqItems)
        }
    }

    const handleVerifyHSNCode = (e) => {
        if (e.target.value.length > 4) {
            const relatedHSNCodes = HSNMasterData.filter(eachCode => eachCode.HSNCode === parseInt(e.target.value))

            if (relatedHSNCodes.length === 0) {
                dispatch(raiseToast({ severity: 'error', detail: "Invalid HSN", life: 3000 }))
            }
        }
    }

    const getGSTRatesByHSNCode = (hsnCode) => {
        let relatedGstOptions = gstOptions.filter(eachGST => {
            if(hsnCode){
                const relatedHSNCodes = HSNMasterData.filter(eachHSN => eachHSN.HSNCode === parseInt(hsnCode))
                if(relatedHSNCodes.length){
                    const relatedGSTRates = relatedHSNCodes.map(eachHSN => eachHSN.GSTRate)
                    return relatedGSTRates.includes(eachGST.GSTRate)
                }
            }
            return false
        })

        if ((sellerDetails && sellerDetails.gstinCode === "URD") || isZeroGstRateExists){
            const isZeroGstRateExists = relatedGstOptions.find(eachGSTOption => eachGSTOption.GSTRate === 0)

            if (!isZeroGstRateExists){
                relatedGstOptions.push({label: "0", GSTRate: 0})
            }
        }
        return relatedGstOptions
    }

    // const renderPrevTransPopupTemplate = (prevTransactions) => {
    //     if (!prevTransactions || prevTransactions.length === 0) return <p className="text-center">{`No Transactions`}</p>

    //     if(isPrevTransLoading) return <p className="text-center">Loading...</p>
    //     return (
    //         <>
    //             {prevTransactions.map((eachTrans, index) => {
    //                 return (
    //                     <div className="col-12" key={`transaction-${eachTrans.buyerPOItemId}`}>
    //                         <div className="flex">
    //                             <span className="align-items-start font-semibold text-600" style={{ marginRight: index+1 > 9 ? "9px" : "15px"}}>{index + 1}.</span>
    //                             <div className="">
    //                                 <span><span className="font-semibold">{eachTrans.margin}%</span> on {getDateString(eachTrans.createdAt)} from {eachTrans.sellerCompany}(₹{eachTrans.sPOUnitPrice}) to {eachTrans.buyerCompany}(₹{eachTrans.bPOUnitPrice})</span>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 )
    //             })}
    //         </>
    //     )
    // }    

    const isHSNEntryAllowed = PMCompanyConfig.HSNEntryAllowed

    const materialsWithImages = relatedSellerReqItems.filter(eachSelReqItem => {
        const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === eachSelReqItem.materialId)
        if(relatedMaterial && relatedMaterial.materialImage){
            if(relatedMaterial.materialImage.length){
                return true
            }
        }
        return false
    })
    const materialIdsWithImages = materialsWithImages.map(eachMaterial => eachMaterial.materialId)

    let isDummySeller = sellerDetails && sellerDetails.companyId === 3625

    let panelStyle = {
        padding:"0px"
    }

    if(isDummySeller){
        panelStyle.border = "1px solid red"
        panelStyle.borderRadius =  "6px"
    }

    // style={{border: sellerReq.isNew ? "solid" : "none", borderColor: sellerReq.isNew ? "#babcbd" : ""}}
    return (
        <div>
            {
                isDummySeller ?
                    <div>
                        <Button label="Dummy seller" className="seller-req-header-name" style={{ width: "180px", height: "25px" }} />
                    </div>
                    : null
            }
            <Panel className="mb-2 vendor-component-panel p-0" id={sellerDetails?.userId} ref={panelRef} style={panelStyle} headerTemplate={vendorTemplate} toggleable>
            <div className="p-0">
            {
                relatedSellerReqItems.map((eachSellerReqItem, index) => {
                    const relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachSellerReqItem.buyerReqItemId)
                    const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachSellerReqItem?.materialId)

                    const quoteAmountValues = totalQuotationAmountCalculation(eachSellerReqItem)

                    let textDecoration = eachSellerReqItem.statusId === 2 ? "line-through" : ""
                    let label = eachSellerReqItem.statusId === 2 ? "Expired" : "Mark Expired"
                    let expiredIcon = eachSellerReqItem?.statusId === 1 ? "" : "pi pi-exclamation-triangle"

                    let isDisabled = ((eachSellerReqItem.statusId === 1) && !(eachSellerReqItem?.quotTotalAmountWithTax > 0)) ? false : true

                    let isQuotationEntered = eachSellerReqItem?.quotQty > 0 && eachSellerReqItem?.quotTotalAmountWithTax > 0
                    let dateString = getDateString(eachSellerReqItem?.updatedAt)
                    let tooltip = `Quotation Entered On ${dateString}`
                    let productName = getProductName(relatedMaterial?.brandName, relatedMaterial?.productName, relatedMaterial?.variantName)
                    let productSpecification = getBuyerProductSpecification(relatedMaterial?.companyProdSpec, relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)

                    let isDiscountApplicable = buyerDetails?.tags?.displayBuyerQuoteDiscount ? buyerDetails?.tags?.displayBuyerQuoteDiscount : false

                    const relatedVendorRateContractItem = vendorRateContractItems.find(eachVendorRateContract => eachVendorRateContract.vendorRateContractItemId === eachSellerReqItem.vendorRateContractItemId)

                    let vrcDiscoundCond = false
                    let vrcListPriceCond = false
                    let vrcUnitPriceCond = false
                    let vrcLeadTimeCond = false

                    if (relatedVendorRateContractItem && relatedVendorRateContractItem.vendorRCTypeId === 1) {
                        vrcDiscoundCond = true
                        vrcLeadTimeCond = true
                    }
                    if (relatedVendorRateContractItem && relatedVendorRateContractItem.vendorRCTypeId === 2) {
                        vrcUnitPriceCond = true
                        vrcDiscoundCond = true
                        vrcListPriceCond = true
                        vrcLeadTimeCond = true
                    }
                    if (relatedVendorRateContractItem && relatedVendorRateContractItem.vendorRCTypeId === 3) {
                        vrcUnitPriceCond = true
                        vrcLeadTimeCond = true
                        if (relatedVendorRateContractItem.listPrice) {
                            vrcDiscoundCond = true
                            vrcListPriceCond = true
                        }
                    }

                    const relatedPastSellerPOMaterialTransactions = pastSellerPOMaterialTransactions.filter(eachSelPOMaterial => eachSelPOMaterial.materialId === eachSellerReqItem.materialId)

                    let quotePercentileImg = ''
                    let quotePercentileTooltipText = ''
                    if(relatedPastSellerPOMaterialTransactions.length && relatedPastSellerPOMaterialTransactions.length >= 3&& eachSellerReqItem.quotUnitPrice && eachSellerReqItem.statusId === 1){
                        const allUnitPrices = relatedPastSellerPOMaterialTransactions.map(eachMatTransaction => eachMatTransaction.unitPrice)
                        const percentile = getReversePercentile(allUnitPrices, eachSellerReqItem.quotUnitPrice)

                        const minPrice = _.min(allUnitPrices)
                        if(minPrice && minPrice >= eachSellerReqItem.quotUnitPrice){
                            quotePercentileImg = "https://procmart-dev.s3.ap-south-1.amazonaws.com/SellerRegistration/GSTCertificate/ce24ce68-bcde-4fb2-abd7-197073f0f96f.png"
                            quotePercentileTooltipText = `Percentile: ${percentile}`
                        }
                        else if(percentile >= 20){
                            quotePercentileImg = "https://procmart-dev.s3.ap-south-1.amazonaws.com/SellerRegistration/IncorporationCertificate/045571a6-17cb-437d-a745-44994a03095a.png"
                            quotePercentileTooltipText = `Percentile: ${percentile}`
                        }
                        else if(percentile < 20){
                            quotePercentileImg = "https://procmart-dev.s3.ap-south-1.amazonaws.com/SellerRegistration/MSMEDCertificate/2834e5ec-72c0-40dd-9368-41ca6c9e971f.png"
                            quotePercentileTooltipText = `We think this item can be at a better price - Have you tried negotiating with the vendor well?`
                        }
                    }

                    let canApplyPastValues = true 
                    if(sellerReq.disabled){
                        canApplyPastValues = false
                    }
                    if(!eachSellerReqItem.isEditable){
                        canApplyPastValues = false
                    }

                    const relatedGSTOptions = sellerReq.companyId === sellerReq.pmCompanyId ? gstOptions : getGSTRatesByHSNCode(eachSellerReqItem.quotHSNCode)

                    return (
                        <div key={`sellerReqItem-${eachSellerReqItem.sellerReqItemId}`}>
                            <div className="">
                                <Loading visible={isLoading} />
                                <div className="flex flex-row mb-2 p-1 align-items-center" style={{flex:1, justifyContent:"space-between"}}>
                                    <div className="flex flex-row">
                                    <p style={{textDecoration: textDecoration}} className="pr-1"><span style={{fontWeight : 700}} className={isQuotationEntered && `custom-tool-tip-${eachSellerReqItem?.materialId}`}>{relatedBuyerReqItem?.materialId}</span>{productName && ` | ${productName}`} {productSpecification && ` | ${productSpecification}`}</p>
                                    {
                                        isQuotationEntered &&
                                        <Tooltip target={`.custom-tool-tip-${eachSellerReqItem?.materialId}`} position="right" autoHide >
                                            <p className="m-0">{tooltip}</p>
                                        </Tooltip>
                                    }
                                    </div>
                                    <div className="flex flex-row ml-2"> 
                                        <Expiry 
                                            sellerReqItem={eachSellerReqItem} 
                                            label={label} 
                                            sellerReqsData={sellerReqsData} 
                                            setSellerReqs={setSellerReqs} 
                                            setInitialSellerReqs={setInitialSellerReqs} 
                                            sellerReq={sellerReq} 
                                            handleExpiryClick={handleExpiryClick} 
                                            setFormErrors={setFormErrors} 
                                            materialMandatoryUseFromStock={materialMandatoryUseFromStock} 
                                            buyerReq={buyerReq} 
                                            companyWarehousesData={companyWarehousesData}
                                            PMBranches={PMBranches}
                                            sellerDetails={sellerDetails}
                                            relatedVendorRateContractItem={relatedVendorRateContractItem}
                                        />
                                        <div className="p-1 flex align-items-center">
                                            <label className="text-sm mr-2 ml-3"> Logistics Charge:</label>
                                            <InputSwitchField className="p-2" name="showLogistics" checked={eachSellerReqItem.showLogistics} disabled={eachSellerReqItem?.statusId === 2 || !eachSellerReqItem?.canEditExpiredAndLogistics} onChange={(e) => handleToggle(e.target.name, e.value, eachSellerReqItem.sellerReqItemId)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid mb-2 align-items-center">
                                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                        <TextInputField name="quotQty" labelText='Q.Qty' errorMessage={formErrors[`[${index}].quotQty`]} disabled={!eachSellerReqItem?.isEditable || sellerReq?.companyId === sellerReq.pmCompanyId} value={eachSellerReqItem.quotQty} keyfilter={"pnum"} onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId})}/>
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                        <TextInputField name="quotLeadTime" labelText='Q.LeadTime'  tooltip={"Delivery period in days"} errorMessage={formErrors[`[${index}].quotLeadTime`]} disabled={!eachSellerReqItem?.isEditable || !eachSellerReqItem?.quotQty > 0} value={eachSellerReqItem.quotLeadTime} keyfilter={"pnum"} onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId,  vrcLeadTimeCond})}/>
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                        <TextInputField name="quotListPrice" labelText='Q.ListPrice' errorMessage={formErrors[`[${index}].quotListPrice`]} disabled={!eachSellerReqItem?.isEditable || !eachSellerReqItem?.quotQty > 0 || vrcListPriceCond} value={eachSellerReqItem.quotListPrice} keyfilter={"pnum"}  onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId, vrcUnitPriceCond})}/>
                                    </div>
                                    {
                                        isHSNEntryAllowed ?
                                            <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                                <div className="flex">
                                                    <label style={{ fontSize: "12px", marginBottom: "3px" }}>
                                                        Q.HSN
                                                    </label>
                                                    {
                                                        <>
                                                            {eachSellerReqItem.isHSNEditable ?
                                                                <div>
                                                                    <i className='pi pi-save ml-1 cursor-pointer' style={{ fontSize: '0.7rem', color: "green" }} onClick={() => { handleHSNSave(eachSellerReqItem.sellerReqItemId, eachSellerReqItem.quotHSNCode) }}></i>
                                                                    <i className='pi pi-times ml-1 cursor-pointer ml-2' style={{ fontSize: '0.7rem', color: "red" }} onClick={() => { handleHSNDiscard(eachSellerReqItem.sellerReqItemId) }}></i>
                                                                </div>
                                                                :
                                                                <i className='pi pi-pencil ml-1 cursor-pointer' style={{ fontSize: '0.7rem' }} onClick={() => handleHSNCodeEditable(eachSellerReqItem.sellerReqItemId, eachSellerReqItem.isEditable)}></i>
                                                            }
                                                        </>
                                                    }
                                                </div>
                                                <TextInputField name="quotHSNCode" errorMessage={formErrors[`[${index}].quotHSNCode`]} disabled={!eachSellerReqItem?.isEditable || !eachSellerReqItem.isHSNEditable} value={eachSellerReqItem.quotHSNCode} keyfilter={"num"} onBlur={(e) => handleVerifyHSNCode(e)} onChange={(e) => handleChange({ e, sellerReqItemId: eachSellerReqItem.sellerReqItemId })} />
                                            </div>
                                            :
                                            null
                                    }
                                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                        <TextInputField name="quotDiscountRate" labelText='Q.Disc(%)' errorMessage={formErrors[`[${index}].quotDiscountRate`]} disabled={!eachSellerReqItem?.isEditable || !eachSellerReqItem?.quotQty > 0 || vrcDiscoundCond} value={eachSellerReqItem.quotDiscountRate} keyfilter={"pnum"}  onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId, vrcUnitPriceCond})}/>
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                        <TextInputField name="quotUnitPrice" labelText='Q.UnitPrice' errorMessage={formErrors[`[${index}].quotUnitPrice`]} disabled={!eachSellerReqItem?.isEditable || !eachSellerReqItem?.quotQty > 0 || sellerReq?.companyId === sellerReq.pmCompanyId || isDiscountApplicable || vrcUnitPriceCond} value={eachSellerReqItem.quotUnitPrice} keyfilter={"pnum"} onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId, vrcDiscoundCond})}/>
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                        <DropDownField name="quotGSTRate" labelText={PMCompanyConfig.GSTRateLabel} value={eachSellerReqItem?.quotGSTRate} errorMessage={formErrors[`[${index}].quotGSTRate`]} options={relatedGSTOptions} optionLabel="label" optionValue="GSTRate" disabled={!eachSellerReqItem?.isEditable || sellerDetails.gstinCode === "URD" || !eachSellerReqItem?.quotQty > 0 || sellerReq?.companyId === sellerReq.pmCompanyId} keyfilter="num" onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId})}/>
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                        <TextInputField name="quotTotalAmountBeforeTax" labelText='Amt. Before Tax' disabled value={numberConversion(quoteAmountValues?.totalAmountBeforeTax, numberLocale)} keyfilter="num" onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId})}/>
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                        <TextInputField name="quotTotalAmountWithTax" labelText='Amt. With Tax' disabled value={numberConversion(quoteAmountValues?.totalAmountWithTax, numberLocale)} keyfilter="num" onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId})}/>
                                    </div>
                                    <div className="flex col-12 mb-2 lg:col-1 lg:mb-0 justify-content-around">
                                        {
                                            eachSellerReqItem.statusId === 1 &&
                                            <MaterialsPreviousTransactions
                                                relatedPastSellerPOMaterialTransactions={relatedPastSellerPOMaterialTransactions}
                                                isPrevSelPOMaterialTransactionsLoading={isPrevSelPOMaterialTransactionsLoading}
                                                PMCompanyConfig={PMCompanyConfig}
                                                canApplyPastValues={canApplyPastValues}
                                                handleApplySellerPOPastValues={handleApplySellerPOPastValues}
                                                identifier={eachSellerReqItem.sellerReqItemId}
                                                appliedValue={eachSellerReqItem}
                                            />
                                        }
                                        {
                                            quotePercentileImg &&
                                            <div className={`flex  align-items-center quote-percentile-tooltip-${eachSellerReqItem.sellerReqItemId}`}>
                                                <img src={quotePercentileImg} style={{ width: '1.5rem', height: '1.5rem' }} className={`cursor-pointer`} />
                                                <Tooltip content={quotePercentileTooltipText} target={`.quote-percentile-tooltip-${eachSellerReqItem.sellerReqItemId}`} />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="grid">
                                    {
                                        eachSellerReqItem.showLogistics && 
                                            <>
                                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                                    <TextInputField name="quotLogisticsBeforeTax"  labelText='Q.Logistics Before Tax' disabled={isDisabled || sellerReq?.disabled || !eachSellerReqItem?.quotQty > 0} value={eachSellerReqItem.quotLogisticsBeforeTax} keyfilter="num" onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId})}/>
                                                </div>
                                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                                    <DropDownField name="quotLogisticsGSTRate"  labelText='Q.Logistics GST Rate' options={gstOptions} optionLabel="label" optionValue="GSTRate" disabled={isDisabled || sellerReq?.disabled || !eachSellerReqItem?.quotQty > 0} value={eachSellerReqItem.quotLogisticsGSTRate ? eachSellerReqItem.quotLogisticsGSTRate : 0} keyfilter="num" onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId})}/>
                                                </div>
                                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                                    <TextInputField name="quotLogisticsWithTax"  labelText='Q.Logistics With Tax' disabled value={quoteAmountValues?.quotLogisticsWithTax} keyfilter="num" onChange={(e)=> handleChange({e, sellerReqItemId: eachSellerReqItem.sellerReqItemId})}/>
                                                </div>
                                            </>
                                    }
                                </div>
                                { index > 1 && <div className="hr-line"  style={{ backgroundColor: "#c0c2c4"}}/> }
                            </div>
                    </div>
                )})
            }
            </div>
            <Dialog visible={visibleMaterialImagesConfirmation} style={{ width: '25vw', height: '28vh' }} onHide={() => setVisibleMaterialImagesConfirmation(false)} footer={handleMaterialImagesConfirmationFooter}>
                <p>Images found uploaded against material ID(s) {materialIdsWithImages.join(", ")}. Do you want to attach these to the email?</p>
            </Dialog>
        </Panel>
        </div>
    )
}

export default VendorComponent;